import {createAsyncThunk} from "@reduxjs/toolkit";
import {Request} from "../request";
import {toast} from "react-toastify";
import {smsState} from "./sms.slice";

export const getSms = createAsyncThunk(
    "/sms/get",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await Request.get(`sms/${id}`)
            return response
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

export const getSmsList = createAsyncThunk(
    "/sms/getAll",
    async (params: any, { getState, rejectWithValue }: any) => {
        try {
            const { offset, limit } = getState().sms as smsState
            const response = await Request.get(
                `sms?text=${params.text}&offset=${0}&limit=${limit}&direction=${params.direction}&date_start=${params.start}&date_end=${params.end}&campaign=${params.campaign_id}&all=${params.show_all}&userId=${params.userId}`
            )
            return response
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

export const loadMoreSms = createAsyncThunk(
    "/sms/load",
    async (params: any, { getState, rejectWithValue }: any) => {
        try {
            const { offset, limit } = getState().sms as smsState
            const response = await Request.get(
                `sms?text=${params.text}&offset=${offset}&limit=${limit}&direction=${params.direction}&date_start=${params.start}&date_end=${params.end}&campaign=${params.campaign_id}&all=${params.show_all}&userId=${params.userId}`
            )
            return response
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

export const sendSms = createAsyncThunk(
    "/sms/send",
    async (payload: any, { getState, rejectWithValue }: any) => {
        try {
            const response = await Request.post('sms/send', payload)

            toast('Sent', { type: 'success' })
            return response
        } catch (error: any) {
            toast('some error', { type: 'error' })
            return rejectWithValue(error);
        }
    }
);

export const autocompleteSms = createAsyncThunk(
    "/sms/autocomplete",
    async (text: string, { rejectWithValue }: any) => {
        try {
            const response = await Request.get(`sms/autocomplete?text=${text}`)
            return response
        } catch (error: any) {
            return rejectWithValue(error);
        }
    }
);

export const downloadXLSX = createAsyncThunk(
    "sms/download",
    async (
        {date, text, direction, campaignId, showAll, userID}: {
            date: any, text: string,
            direction: string, campaignId: string,
            showAll: boolean, userID: string
        },
        { rejectWithValue }: any
    ) => {
        try{
            const response = await Request.get(`sms/download?text=${text}&date_start=${date[0]}&date_end=${date[1]}&direction=${direction}&campaign=${campaignId}&all=${showAll}&userId=${userID}`)
            return response
        }
        catch (error: any)
        {
            return rejectWithValue(error);
        }
    }
)

export const fileDownload = createAsyncThunk(
    "file/download",
    async ({ file }: { file: string }, { rejectWithValue }) => {
        try {
            const response = await Request.request(`file/download?file=${file}`, {
                method: 'GET',
                responseType: 'blob',
            });

            // console.log('✅ Response:', response);

            const contentType = response.headers?.['content-type'] ?? 'application/octet-stream';

            const blob = new Blob([response.data], { type: contentType });

            // console.log('👉 Blob size:', blob.size);

            const preview = await blob.text();
            // console.log('👉 Blob text preview:', preview.slice(0, 300));

            // имя файла из Content-Disposition
            let fileName = 'download.xlsx';
            const disposition = response.headers?.['content-disposition'];
            if (disposition) {
                const match = disposition.match(/filename="?(.+?)"?$/);
                if (match && match[1]) {
                    fileName = decodeURIComponent(match[1]);
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            return true;
        } catch (error: any) {
            // console.error('Download error:', error);
            return rejectWithValue(error?.message || 'Unknown error');
        }
    }

)